import { labelids } from "../../assets/data/TkExplanationProperty";
import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";

const stepper = [
  "退職者の基本情報登録",
  "従業状況の登録確認",
  "退職した月の本俸月額登録",
  "登録内容の確認",
  "機構へ提出",
];
const childHeadList: any[] = [
  {
    headTitle: "順番",
  },
  {
    headTitle: "出産日",
  },
  {
    headTitle: "育児休業開始日",
  },
  {
    headTitle: "育児休業終了日",
  },
  {
    headTitle: "パパ・ママ育休プラス",
  },
  {
    headTitle: "半年延長の理由",
  },
  {
    headTitle: "産後パパ育休",
  },
];

const salaryHeadList: any[] = [
  {
    headTitle: "年月",
  },
  {
    headTitle: "俸給表の額",
  },
  {
    headTitle: "俸給の調整額",
  },
];

const fakeTableList: ITkFakeTableLineProps[] = [
  {
    keyword: "info",
    type: "explanatoryText",
    explanatoryText: labelids.labelid.LBLC060028_01,
  },
  {
    keyword: "contractorName",
    type: "contractorAndNumber",
    contractorName: "契約者（法人）名",
    showLine: false,
  },
  {
    title: "職員番号",
    keyword: "staffNo",
    type: "text",
  },
  {
    title: "退職者名カナ",
    keyword: "bNameKana",
    type: "text",
  },
  {
    title: "退職者名",
    keyword: "bNameKanji",
    type: "text",
  },
  {
    title: "退職者名カナ（新）",
    keyword: "staffNameKana",
    type: "text",
    showLine: true,
  },
  {
    title: "退職者名（新）",
    keyword: "staffNameKanji",
    type: "text",
    showLine: true,
  },
  {
    title: "退職者生年月日",
    keyword: "birthday",
    type: "text",

    helpText: "退職者の生年月日です。",
  },
  {
    title: "退職年月日",
    keyword: "retireDate",
    type: "text",
  },
  {
    title: "退職理由",
    keyword: "retireReason",
    type: "text",
  },
  {
    title: "退職手続きの理由",
    keyword: "retireProcedureReason",
    type: "text",

    helpText:
      "「普通退職」における「死亡による退職」とは、業務災害（通勤災害）に起因する死亡以外によって退職する場合が該当します。また、「普通退職」における「法人（業務上の）都合」とは、共済契約者間で施設運営上の理由により人材を融通することを事前に合意した転職のみが対象となります。それ以外のケースについては、自己都合による退職となります。",
  },
  {
    title: "退職者郵便番号",
    keyword: "zipcode",
    type: "text",

    helpText: "退職者の居住場所の郵便番号です。",
  },
  {
    title: "退職者住所",
    keyword: "address",
    type: "text",

    helpText: "退職者の居住場所の住所です。",
  },
  {
    title: "退職者電話番号",
    keyword: "tel",
    type: "text",

    helpText: "退職者に連絡が取れる電話番号（携帯電話可）です。",
  },
  {
    title:
      "現在の共済契約者と転職先の共済契約者が、施設運営上の理由により人材を融通することを事前に合意した転職である",
    keyword: "continueTransferApplicable1Flg",
    type: "text",
  },
  {
    title:
      "現在の共済契約者の退職日の翌日が、転職先の共済契約者への就職日である",
    keyword: "continueTransferApplicable2Flg",
    type: "text",
  },
  {
    title: "転職先の共済契約者番号",
    keyword: "aContractorNo",
    type: "text",
    showLine: false,
  },
  {
    title: "転職先の共済契約者名",
    keyword: "aCorpName",
    type: "text",
    showLine: false,
  },
  {
    title: "ならない月",
    keyword: "exclusionMonth",
    type: "checkboxGroup",
    checkBoxList: [
      { label: "無", value: "none", disabled: true },
      { label: "4月", value: "apr", disabled: true },
      { label: "5月", value: "may", disabled: true },
      { label: "6月", value: "jun", disabled: true },
      { label: "7月", value: "jul", disabled: true },
      { label: "8月", value: "aug", disabled: true },
      { label: "9月", value: "sep", disabled: true },
      { label: "10月", value: "oct", disabled: true },
      { label: "11月", value: "nov", disabled: true },
      { label: "12月", value: "dec", disabled: true },
      { label: "1月", value: "jan", disabled: true },
      { label: "2月", value: "feb", disabled: true },
      { label: "3月", value: "mar", disabled: true },
    ],
  },
  {
    title: "当月の出勤日数",
    keyword: "workingDayNum",
    type: "text",
  },
  {
    title: "賃金台帳",
    keyword: "wages",
    type: "downloadLink",
    downloadBase64: true,
    showLine: false,
  },
  {
    title: "雇用契約書",
    keyword: "contractEmployment",
    type: "downloadLink",
    downloadBase64: true,
    showLine: false,
  },
];
export { fakeTableList, childHeadList, salaryHeadList, stepper };
